module.exports = __webpack_public_path__ + "img/pharmaceuticals.9d5907de.png";